// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_OqQKA {
  width: 400px;
  height: 100%;
}

.pad_rMiHW {
  padding: var(--size-padLarge, 10px);
}

.header_yQNy0 {
  position: relative;
}

.contentArea_dUaLg {
  background: #f3f5f6;
}

.close_Rrkzs {
  position: absolute;
  z-index: 1;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

.successImage_OBMpR {
  margin: 20px auto;
  display: block;
}

.buttonContainer_TWqbF {
  width: 100%;
  background-color: white;
  border-radius: 6px;
  box-shadow: rgba(41, 50, 61, 0.16) 0px 1px 3px;
  padding: 0 10px;
}

.buttonContainer_TWqbF > * {
  border-bottom: 1px solid var(--color-base200) !important;
}

.buttonContainer_TWqbF > *:last-child {
  border-bottom: none !important;
}

.loadingArea_n3lX5 {
  height: 100%;
  width: 100%;
}

.ordinal_h6tby {
  height: 22px;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/r4k/views/keyTagPairing/Pair.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;AACd","sourcesContent":[".content {\n  width: 400px;\n  height: 100%;\n}\n\n.pad {\n  padding: var(--size-padLarge, 10px);\n}\n\n.header {\n  position: relative;\n}\n\n.contentArea {\n  background: #f3f5f6;\n}\n\n.close {\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n}\n\n.successImage {\n  margin: 20px auto;\n  display: block;\n}\n\n.buttonContainer {\n  width: 100%;\n  background-color: white;\n  border-radius: 6px;\n  box-shadow: rgba(41, 50, 61, 0.16) 0px 1px 3px;\n  padding: 0 10px;\n}\n\n.buttonContainer > * {\n  border-bottom: 1px solid var(--color-base200) !important;\n}\n\n.buttonContainer > *:last-child {\n  border-bottom: none !important;\n}\n\n.loadingArea {\n  height: 100%;\n  width: 100%;\n}\n\n.ordinal {\n  height: 22px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_OqQKA`,
	"pad": `pad_rMiHW`,
	"header": `header_yQNy0`,
	"contentArea": `contentArea_dUaLg`,
	"close": `close_Rrkzs`,
	"successImage": `successImage_OBMpR`,
	"buttonContainer": `buttonContainer_TWqbF`,
	"loadingArea": `loadingArea_n3lX5`,
	"ordinal": `ordinal_h6tby`
};
export default ___CSS_LOADER_EXPORT___;
